import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';
const firebaseConfig = {
    apiKey: "AIzaSyDch0gqDV3ticpDLJOC9CL8iszyiWS4UzQ",
    authDomain: "amcouch-66267.firebaseapp.com",
    projectId: "amcouch-66267",
    storageBucket: "amcouch-66267.appspot.com",
    messagingSenderId: "48186723695",
    appId: "1:48186723695:web:e3d4bc81ee136b54692c9a"
};
const app = initializeApp(firebaseConfig);

// Initialize Firestore
const db = getFirestore(app);

export { db };